/** @var globalThis */
export default class LadderLocalStorage {

	constructor() {

	}

	static setItem(key, object) {
		localStorage.setItem(key, JSON.stringify(object));
		return object;
	}

	static getItem(key, defaultValue) {
		const value = localStorage.getItem(key);
		if(value === null) {
			return defaultValue;
		}
		return JSON.parse(localStorage.getItem(key));
	}

	static incrementKey(key) {
		if(!localStorage.getItem(key)) {
			localStorage.setItem(key, 0);
		}
		localStorage.setItem(key,
			parseInt(localStorage.getItem(key)) + 1
		);
		return this.getIntValue(key);
	}

	static getIntValue(key) {
		return parseInt(localStorage.getItem(key));
	}

	static removeItem(key) {
		return localStorage.removeItem(key);
	}
}
if(!globalThis.localStorage) {
	globalThis.localStorage = {};
	localStorage.setItem = function() {
	};
	localStorage.getItem = function() {
		return null;
	};
	localStorage.removeItem = function() {
	};
}